var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInPersonClass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9316 4.56123H22.6218V31.554H62.9316V4.56123ZM61.1911 29.8175H24.3563V6.29771H61.1931L61.1911 29.8175Z",
    fill: "url(#paint0_linear_101_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.083 26.1007H53.0935V28.6063H60.083V26.1007Z",
    fill: "url(#paint1_linear_101_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4347 20.7188C12.263 20.7188 13.7452 19.2367 13.7452 17.4084C13.7452 15.5801 12.263 14.098 10.4347 14.098C8.60645 14.098 7.12433 15.5801 7.12433 17.4084C7.12433 19.2367 8.60645 20.7188 10.4347 20.7188Z",
    fill: "url(#paint2_linear_101_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1885 38.3611V29.1059H20.8794V26.3961H14.5321L14.3953 21.7159L11.7133 21.2164L10.4922 22.6793L9.22951 21.2164L6.30961 21.7199V26.3961H0V29.1059H1.69089V38.3611H19.1885Z",
    fill: "url(#paint3_linear_101_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.561 45.9731C50.6887 45.9731 51.6028 45.059 51.6028 43.9314C51.6028 42.8037 50.6887 41.8896 49.561 41.8896C48.4334 41.8896 47.5193 42.8037 47.5193 43.9314C47.5193 45.059 48.4334 45.9731 49.561 45.9731Z",
    fill: "url(#paint4_linear_101_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9313 45.9731C60.0589 45.9731 60.9731 45.059 60.9731 43.9314C60.9731 42.8037 60.0589 41.8896 58.9313 41.8896C57.8037 41.8896 56.8896 42.8037 56.8896 43.9314C56.8896 45.059 57.8037 45.9731 58.9313 45.9731Z",
    fill: "url(#paint5_linear_101_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1897 45.9731C40.3174 45.9731 41.2315 45.059 41.2315 43.9314C41.2315 42.8037 40.3174 41.8896 39.1897 41.8896C38.0621 41.8896 37.148 42.8037 37.148 43.9314C37.148 45.059 38.0621 45.9731 39.1897 45.9731Z",
    fill: "url(#paint6_linear_101_2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1227 45.9692C29.2492 45.9692 30.1624 45.0559 30.1624 43.9294C30.1624 42.8028 29.2492 41.8896 28.1227 41.8896C26.9961 41.8896 26.0829 42.8028 26.0829 43.9294C26.0829 45.0559 26.9961 45.9692 28.1227 45.9692Z",
    fill: "url(#paint7_linear_101_2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4421 45.7789C18.5697 45.7789 19.4839 44.8647 19.4839 43.7371C19.4839 42.6095 18.5697 41.6954 17.4421 41.6954C16.3145 41.6954 15.4004 42.6095 15.4004 43.7371C15.4004 44.8647 16.3145 45.7789 17.4421 45.7789Z",
    fill: "url(#paint8_linear_101_2)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8151 45.7769C7.94163 45.7769 8.85487 44.8636 8.85487 43.7371C8.85487 42.6106 7.94163 41.6973 6.8151 41.6973C5.68857 41.6973 4.77533 42.6106 4.77533 43.7371C4.77533 44.8636 5.68857 45.7769 6.8151 45.7769Z",
    fill: "url(#paint9_linear_101_2)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M49.561 53.254C51.1835 53.254 52.4988 51.9388 52.4988 50.3163C52.4988 48.6938 51.1835 47.3786 49.561 47.3786C47.9386 47.3786 46.6233 48.6938 46.6233 50.3163C46.6233 51.9388 47.9386 53.254 49.561 53.254Z",
    fill: "url(#paint10_linear_101_2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6929 53.6921L49.6106 54.9945L48.4906 53.6921L45.8978 54.1857V59.3535H53.2283L53.1093 54.2273L50.6929 53.6921Z",
    fill: "url(#paint11_linear_101_2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9122 53.2501C40.5336 53.2501 41.848 51.9357 41.848 50.3143C41.848 48.6929 40.5336 47.3786 38.9122 47.3786C37.2909 47.3786 35.9765 48.6929 35.9765 50.3143C35.9765 51.9357 37.2909 53.2501 38.9122 53.2501Z",
    fill: "url(#paint12_linear_101_2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0481 53.6921L38.9657 54.9945L37.8458 53.6921L35.2509 54.2273V59.3535H42.5794L42.4328 54.2273L40.0481 53.6921Z",
    fill: "url(#paint13_linear_101_2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.09 48.3657C45.2767 48.3657 46.2388 47.4037 46.2388 46.2169C46.2388 45.0302 45.2767 44.0681 44.09 44.0681C42.9032 44.0681 41.9412 45.0302 41.9412 46.2169C41.9412 47.4037 42.9032 48.3657 44.09 48.3657Z",
    fill: "url(#paint14_linear_101_2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.766 52.697C46.3834 51.9735 46.1198 51.1865 46.1198 50.3123C46.1198 49.7375 46.2704 49.2003 46.4488 48.6849H46.2387H45.7134H44.9185L44.1276 49.6364L43.3109 48.6849H42.4664H41.9986C42.2147 49.1844 42.3396 49.7355 42.3396 50.3123C42.3396 51.2579 42.0066 52.1222 41.4614 52.8298H46.77V52.697H46.766Z",
    fill: "url(#paint15_linear_101_2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1227 53.254C29.7451 53.254 31.0604 51.9388 31.0604 50.3163C31.0604 48.6938 29.7451 47.3786 28.1227 47.3786C26.5002 47.3786 25.1849 48.6938 25.1849 50.3163C25.1849 51.9388 26.5002 53.254 28.1227 53.254Z",
    fill: "url(#paint16_linear_101_2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2565 53.6921L28.1742 54.9945L27.0542 53.6921L24.4594 54.2273V59.3535H31.7879L31.6392 54.2273L29.2565 53.6921Z",
    fill: "url(#paint17_linear_101_2)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2964 48.3657C34.4832 48.3657 35.4452 47.4037 35.4452 46.2169C35.4452 45.0302 34.4832 44.0681 33.2964 44.0681C32.1097 44.0681 31.1476 45.0302 31.1476 46.2169C31.1476 47.4037 32.1097 48.3657 33.2964 48.3657Z",
    fill: "url(#paint18_linear_101_2)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9705 52.697C35.5919 51.9735 35.3203 51.1865 35.3203 50.3123C35.3203 49.7375 35.4789 49.2003 35.6533 48.6849H35.4432H34.9179H34.123L33.3321 49.6364L32.5134 48.6849H31.6709H31.2011C31.4192 49.1844 31.5421 49.7355 31.5421 50.3123C31.5421 51.2579 31.2111 52.1222 30.6639 52.8298H35.9705V52.697Z",
    fill: "url(#paint19_linear_101_2)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3367 53.1173C61.9592 53.1173 63.2745 51.802 63.2745 50.1795C63.2745 48.557 61.9592 47.2418 60.3367 47.2418C58.7143 47.2418 57.399 48.557 57.399 50.1795C57.399 51.802 58.7143 53.1173 60.3367 53.1173Z",
    fill: "url(#paint20_linear_101_2)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8513 54.1064L61.4686 53.5573L60.3863 54.8577L59.2663 53.5573L56.6715 54.1461V59.2207H64L63.8513 54.1064Z",
    fill: "url(#paint21_linear_101_2)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.715 48.2309C55.9028 48.2309 56.8658 47.268 56.8658 46.0802C56.8658 44.8923 55.9028 43.9294 54.715 43.9294C53.5271 43.9294 52.5642 44.8923 52.5642 46.0802C52.5642 47.268 53.5271 48.2309 54.715 48.2309Z",
    fill: "url(#paint22_linear_101_2)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3931 52.5622C57.0144 51.8427 56.7409 51.0537 56.7409 50.1815C56.7409 49.6047 56.8975 49.0694 57.0719 48.5521H56.8638H56.3365H55.5436L54.7566 49.5016L53.936 48.5521H53.0955H52.6277C52.8437 49.0556 52.9666 49.6007 52.9666 50.1775C52.9666 51.1251 52.6356 51.9874 52.0924 52.697H57.403L57.3931 52.5622Z",
    fill: "url(#paint23_linear_101_2)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6066 53.3353C19.2291 53.3353 20.5444 52.02 20.5444 50.3976C20.5444 48.7751 19.2291 47.4598 17.6066 47.4598C15.9842 47.4598 14.6689 48.7751 14.6689 50.3976C14.6689 52.02 15.9842 53.3353 17.6066 53.3353Z",
    fill: "url(#paint24_linear_101_2)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7445 53.7734L17.6602 55.0758L16.5402 53.7734L13.9454 54.2273V59.4388H21.2719L21.1232 54.2273L18.7445 53.7734Z",
    fill: "url(#paint25_linear_101_2)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7824 48.447C23.9691 48.447 24.9312 47.485 24.9312 46.2982C24.9312 45.1115 23.9691 44.1494 22.7824 44.1494C21.5956 44.1494 20.6336 45.1115 20.6336 46.2982C20.6336 47.485 21.5956 48.447 22.7824 48.447Z",
    fill: "url(#paint26_linear_101_2)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4585 52.7803C25.0798 52.0567 24.8103 51.2718 24.8103 50.3996C24.8103 49.8207 24.9649 49.2855 25.1413 48.7681H24.9312H24.4059H23.611L22.82 49.7196L21.9994 48.7681H21.1589H20.6891C20.9052 49.2716 21.032 49.8187 21.032 50.3976C21.032 51.3431 20.699 52.2074 20.1539 52.9151H25.4604L25.4585 52.7803Z",
    fill: "url(#paint27_linear_101_2)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8151 53.3353C8.43647 53.3353 9.75086 52.0209 9.75086 50.3996C9.75086 48.7782 8.43647 47.4638 6.8151 47.4638C5.19372 47.4638 3.87933 48.7782 3.87933 50.3996C3.87933 52.0209 5.19372 53.3353 6.8151 53.3353Z",
    fill: "url(#paint28_linear_101_2)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94896 53.7734L6.86664 55.0758L5.74665 53.7734L3.08246 54.2273L3.15382 59.4388H10.4803L10.3277 54.2273L7.94896 53.7734Z",
    fill: "url(#paint29_linear_101_2)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9889 48.447C13.1756 48.447 14.1376 47.485 14.1376 46.2982C14.1376 45.1115 13.1756 44.1494 11.9889 44.1494C10.8021 44.1494 9.84006 45.1115 9.84006 46.2982C9.84006 47.485 10.8021 48.447 11.9889 48.447Z",
    fill: "url(#paint30_linear_101_2)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6669 52.7803C14.2843 52.0567 14.0167 51.2718 14.0167 50.3996C14.0167 49.8207 14.1733 49.2855 14.3478 48.7681H14.1377H13.6123H12.8175L12.0285 49.7196L11.2078 48.7681H10.3654H9.89953C10.1136 49.2716 10.2405 49.8187 10.2405 50.3976C10.2405 51.3431 9.90746 52.2074 9.36035 52.9151H14.6689L14.6669 52.7803Z",
    fill: "url(#paint31_linear_101_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_2",
    x1: 4.01867e-8,
    y1: 19,
    x2: 65.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_2",
    x1: -0.499999,
    y1: 27,
    x2: 64,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_2",
    x1: 1,
    y1: 17,
    x2: 64.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_2",
    x1: 0.652481,
    y1: 30.4136,
    x2: 64.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_101_2",
    x1: 0.999997,
    y1: 44,
    x2: 64,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_101_2",
    x1: 1,
    y1: 44,
    x2: 64.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_101_2",
    x1: 0.5,
    y1: 44,
    x2: 64.5,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_101_2",
    x1: 1.5,
    y1: 44,
    x2: 63.5,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_101_2",
    x1: 1.5,
    y1: 44,
    x2: 64,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_101_2",
    x1: 1.5,
    y1: 43,
    x2: 63.5,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_101_2",
    x1: 1,
    y1: 51,
    x2: 63.5,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_101_2",
    x1: 1.5,
    y1: 57,
    x2: 64.5,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_101_2",
    x1: 7.31581e-7,
    y1: 51.5,
    x2: 63.5,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_101_2",
    x1: 0.999999,
    y1: 57,
    x2: 64,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_101_2",
    x1: 0.999999,
    y1: 46,
    x2: 63,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_101_2",
    x1: 1,
    y1: 51,
    x2: 64,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_101_2",
    x1: 1,
    y1: 50,
    x2: 64,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_101_2",
    x1: 2,
    y1: 56,
    x2: 64,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_101_2",
    x1: 1,
    y1: 47,
    x2: 63.5,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_101_2",
    x1: 1.5,
    y1: 51,
    x2: 63,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_101_2",
    x1: 1.5,
    y1: 50,
    x2: 63.3663,
    y2: 50.3937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_101_2",
    x1: 1,
    y1: 56,
    x2: 64,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_101_2",
    x1: 0.999994,
    y1: 46,
    x2: 64,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_101_2",
    x1: 1.5,
    y1: 51,
    x2: 64.5,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_101_2",
    x1: 0.5,
    y1: 50,
    x2: 64.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_101_2",
    x1: 1,
    y1: 57,
    x2: 64.5,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_101_2",
    x1: 2,
    y1: 46,
    x2: 63.5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_101_2",
    x1: 0.499999,
    y1: 49,
    x2: 64,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_101_2",
    x1: 1,
    y1: 50,
    x2: 65,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_101_2",
    x1: 3.31364,
    y1: 56.8126,
    x2: 65,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_101_2",
    x1: 1.5,
    y1: 46,
    x2: 64,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_101_2",
    x1: 2,
    y1: 51,
    x2: 64,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1C34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500B0B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPersonClass);
export default __webpack_public_path__ + "static/media/in-person-class.f68c724990417e7885e85601cef43f26.svg";
export { ForwardRef as ReactComponent };